/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMsgWaiting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 40 40"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="#EDA500"
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M22 8v12.512l8.575 2.572 1.915.575-1.149 3.831-1.916-.574-10-3A2 2 0 0 1 18 22V8h4Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgMsgWaiting)
export default Memo
